import { makeVar } from "@apollo/client";
import { PageType } from "../types/Page";

export const pageVar = makeVar<PageType | null>(null);